import React from 'react';
import { WeightedElement } from './constants';

import StandardEndpage from './StandardEndpage';

/**
 * Using a weighted distribution, select and return the page that the target element falls on
 *
 * @param weightedElements object of pages
 * @param target value within distribution range, use a random number [0, 1) if weighted distribution adds up to 1
 * @returns Selected page to serve
 */
export default function WeightedElementSelector(
  weightedElements: WeightedElement[],
  target: number
): React.ReactElement {
  let cumulativeWeight = 0.0;
  let selectedPage = <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />;

  weightedElements.every(element => {
    cumulativeWeight += element.weight;
    if (target < cumulativeWeight) {
      selectedPage = element.page;
      return false;
    }
    return true;
  });

  return selectedPage;
}

export function checkWeightsEqualToOne(weightedElements: WeightedElement[]): boolean {
  let total = 0.0;
  weightedElements.forEach(element => {
    total += element.weight;
  });
  if (Number(total.toFixed(3)) === 1) return true;
  return false;
}
